<template>
  <v-container fluid class="container-full-bg-gray">    
    <div class="blue-div">
      <AppIcon :src="require('@/assets/inmatic_logo.svg')" :size="29" style="padding-bottom: 20px;" />
      <p>Procesando...</p>
    </div>
  </v-container>
</template>
<script>

export default {
  name: 'StripeResult',
  data() {
    return {
    }
  },
  methods: {
  },

  async mounted() {
    const stripe_result = this.$route.query.stripe_result;
    if (window.opener) {
      window.opener.postMessage({stripe_result}, window.location.origin)
    }
    window.close();
  },
}
</script> 

<style scoped>
  .container-full-bg-gray {
    height: 100%;
    background-color: var(--v-background-base);
    padding: 0px;
  }
  .blue-div {
    background-color: var(--v-primary_blue-base);
    height: 211px;
    width: 100%;
    color:var(--v-neutral-base);
    position: relative;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>